import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TipoDealerService } from '../tipo-dealer-service/tipo.dealer.service';
import { CrudBase } from './../../../../shared/crud/CrudBase';
import { ListitemBuilder } from './../../../../shared/dropdown-list/ListItemBuilder';
import { Estado } from './../../../../shared/shared/estado.enum';

@Component({
  selector: 'app-tipo-dealer-cadastro',
  templateUrl: './tipo-dealer-cadastro.component.html',
  styleUrls: ['./tipo-dealer-cadastro.component.css']
})
export class TipoDealerCadastroComponent
extends CrudBase
implements OnInit {

  itensTipo: any;

  constructor(
    service: TipoDealerService,
    toastr: ToastrService
  ) {
    super(service, toastr);
  }

  ngOnInit() {
    if (!this.model) {
      this.model = {};
    }
    this.defineModelVazio();
    this.carregarTipo();
  }

  private carregarTipo() {
    this.itensTipo =
    new ListitemBuilder()
      .add('1S', '1S')
      .add('2S', '2S')
      .add('3S', '3S')
      .build();
  }

  novo() {
    super.novo();
    this.defineModelVazio();
  }

  // == [ INICIO: Métodos Auxiliares ] ==
  private defineModelVazio() {
    if (this.state === Estado.insert) {
      this.model.id = null;
      this.model.tipo = '';
    }
  }
  // == [ FIM:    Métodos Auxiliares ] ==

}
